<template>
    <div id="navbar">
      <router-link to="/home" class="logo">Normcore.</router-link>
      <div id="nav">
        <router-link to="/applications">Applications</router-link>
        <router-link to="/billing">Billing</router-link>
        <a href="https://normcore-docs-vuepress.now.sh/documentation/getting-started.html">Documentation</a>
        <a href="http://normcore.io/discord">Discord</a>
        <a href="#" v-on:click="logout">Logout</a>
      </div>
    </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    msg: String
  },
  methods: {
    logout: function() {
      console.log("we are logging out");
      var newUser = {};
      this.$emit('updateUser', newUser);
      // router.push({ name: 'user', params: { userId: '123' } })
      this.$router.push('login');

    }
  }
};
</script>


<style lang="scss">
#navbar {
  padding: 30px;
  display: flex;
  align-items: center;

  #nav {
      flex:1;
      text-align: right;
      font-size: 0.9em;
  }
  
  a {
    // font-weight: bold;
    // color: $slateGrey;
    text-decoration: none;
    padding: 0 10px;

    &.router-link-exact-active {
      // color: #0041ff;
    }
  }
}
</style>
